import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import {
  CreateUpdateClientDto,
  CreateUpdateClientDtoLanguageEnum,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow, { FormRow66 } from '../../../app/components/FormRow';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { LanguageSelector } from '../Selects/LanguageSelector';
import { Option } from '../Selects/Selector';
import { TooltipKey } from '../../../common/pokCore/tooltip.enum';

interface ClientAdditionalProps {
  client: CreateUpdateClientDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  readonly?: boolean;
}

export const ClientAdditional: React.FC<ClientAdditionalProps> = ({
  client,
  propertyChange,
  readonly = false,
}) => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <Form className="d-grid gap-4 mb-4 mt-4">
      <FormRow controlId="language" label={t(tk.client.languagePreference)}>
        <LanguageSelector
          value={client?.language}
          onChange={(option: Option) =>
            propertyChange?.({
              language: option.value as CreateUpdateClientDtoLanguageEnum,
            })
          }
          readOnly={readonly}
          withName={true}
        />
      </FormRow>
      <FormRow
        controlId="dealGroupNumber"
        label={t(tk.client.dealGroupNumber)}
        tooltipKey={TooltipKey.dealGroupNumberTooltip}
      >
        <Form.Control
          className="d-grid mb-2 mt-2"
          type="text"
          value={client?.dealGroupNumber ?? ''}
          onChange={e =>
            propertyChange?.({
              dealGroupNumber: e.target.value,
            })
          }
          disabled={readonly}
        />
      </FormRow>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="isRelated" label={t(tk.client.isRelated)}>
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.isRelated ?? false}
              onChange={e => propertyChange?.({ isRelated: e.target.checked })}
              disabled={readonly || !!client.companyId}
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="notToSymphony"
            label={t(tk.client.notToSymphony)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.notToSymphony ?? false}
              onChange={e =>
                propertyChange?.({ notToSymphony: e.target.checked })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="internal" label={t(tk.client.internal)}>
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.internal ?? false}
              onChange={e => propertyChange?.({ internal: e.target.checked })}
              disabled={readonly}
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="signContractBlocked"
            label={t(tk.client.signContractBlock)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.signContractBlock ?? false}
              onChange={e =>
                propertyChange?.({
                  signContractBlock: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormRow66 controlId="active" label={t(tk.common.activeHe)}>
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.active ?? true}
              onChange={e => propertyChange?.({ active: e.target.checked })}
              disabled={readonly}
            />
          </FormRow66>
        </Col>
        <Col md={6}>
          <FormRow66
            controlId="notSendMailFVS"
            label={t(tk.client.notSendMailFVS)}
          >
            <Form.Check
              className="d-grid mb-2 mt-2"
              type="checkbox"
              checked={client?.notSendMailFVS ?? false}
              onChange={e =>
                propertyChange?.({
                  notSendMailFVS: e.target.checked,
                })
              }
              disabled={readonly}
            />
          </FormRow66>
        </Col>
      </Row>
    </Form>
  );
};
